import React from 'react';
import {FormGroup, InputGroup} from '@blueprintjs/core';

interface FilenameInputProps {
  filename?: string;
  onChange: (value: any) => void;
  type: string;
}

export const FilenameInput = ({
  filename = '',
  onChange,
  type,
}: FilenameInputProps) => {
  const _onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  }

  return (
    <div className={`merge-${type}-filename-popover`}>
      <FormGroup inline={true} label={'Filenam\uFEFFe'}>
        <InputGroup
          defaultValue={filename}
          autoComplete="off"
          onChange={_onChange}
          placeholder={`merge ${type.toUpperCase()} filename`}
        />
      </FormGroup>
    </div>
  );
};

export default FilenameInput;
